/*
 * Refresh account credits, green dollars, and giving history
 */

(function () {
    // Used in header2.js
    window.refreshAccountCredits = function (callback) {
        refreshOrExtendAccountCredits(false, callback);
    };

    // Used in editPrivateInfo.js
    window.extendAccountCredits = function (callback) {
        refreshOrExtendAccountCredits(true, callback);
        $('#account-credits .error-text').html('');
    };

    function refreshOrExtendAccountCredits(extend, callback) {
        if (userId != null && userId != '') {
            callback = callback || 'saveAndDisplayAccountCredits';
            const e = document.createElement('script');
            e.src = secureBaseURL + 'common/refresh-account-credits.html?callback=' + callback + ((extend) ? '&extend=true' : '');
            e.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(e);
        }
    }

    // Keep this callback's name in sync with RefreshAccountCreditsController.java
    window.saveAndDisplayAccountCredits = function (data) {
        window.createCookie('accountCredits', window.btoa(encodeURIComponent(JSON.stringify(data))), null);
        displayAccountCreditsTip();
    };

    // Used in several JS
    window.displayAccountCreditsTip = function () {
        $('#account-credits-tip').remove();

        const combinedCredits = {};

        const cartGiftCodeAmount = readCookie('cartGiftCodeAmount');
        const cartGiftCodeTotal = (cartGiftCodeAmount != null) ? window.currencyToFloat(cartGiftCodeAmount) : 0;
        if (cartGiftCodeTotal > 0) {
            combinedCredits.giftCode = { availableBalance: cartGiftCodeTotal };
        }

        const accountCredits = readCookie('headerinfo');
        if (accountCredits != null) {
            const accountCreditsDecoded = window.atob(accountCredits);

            const obj = JSON?.parse(accountCreditsDecoded) || $.parseJSON(accountCreditsDecoded);

            if (obj.accountCredits.availableBalance > 0) {
                combinedCredits.accountCredits = obj.accountCredits;
                // for account settings page
                if ($('#account-credits').length > 0) {
                    $('#account-credits h2').html(window.formatCurrency(obj.accountCredits.availableBalance));
                    if (obj.accountCredits.expirationDate) {
                        $('#account-credits .info').html(window.formatMediumDate(obj.accountCredits.expirationDate));
                        const expirationDate = new Date(obj.accountCredits.expirationDate);
                        const nowPlus29Days = new Date();
                        nowPlus29Days.setDate(nowPlus29Days.getDate() + 29);
                        if (expirationDate.getTime() > nowPlus29Days.getTime()) {
                            $('#account-credits .extend').hide();
                        }
                    }
                    if (obj.accountCredits.message) {
                        $('#account-credits .error-text').html(obj.accountCredits.message);
                    }
                }
            }
            // for header
            if (obj.accountCredits.hasMadePurchasesOrDonations) {
                $('.donor-tabs .giving-history').addClass('on');
            } else {
                $('.donor-tabs .giving-history').removeClass('on');
            }
        }

        // for header -- we used to combine the existing balance with any GCs currently being redeemed in this balance,
        //   but decided that's misleading, so only displaying the credit balance.
        let totalAvailable;
        if (combinedCredits.accountCredits) {
            totalAvailable = 0.00;
            if (combinedCredits.accountCredits && combinedCredits.accountCredits.availableBalance) {
                totalAvailable += parseFloat(combinedCredits.accountCredits.availableBalance);
            }
            if (totalAvailable >= parseFloat(1)) {
                combinedCredits.totalAvailable = totalAvailable.toFixed(2);
                const templateV = Handlebars.templates['accountCreditsTip.tmpl'];
                const htmlV = templateV(combinedCredits);
                $('#account-links').prepend(htmlV);
                $('.js-account-credits-tip').on('click', window.toggleAccountCreditsTip);
            }
        }
        // Instead, display the GC amount in the separate banner
        if (combinedCredits.giftCode) {
            totalAvailable = parseFloat(combinedCredits.giftCode.availableBalance);
            if (totalAvailable >= 1) {
                const showGiftCodeRedemptionBanner = function (gcRedemptionAmount) {
                    $('.use-credits-container .message').html('To use your <strong>$' + gcRedemptionAmount + ' gift card credits</strong>, ' +
                        "find a project to fund and we'll automatically apply your credits at checkout.");
                    $('.use-credits-header').addClass('on');
                };

                showGiftCodeRedemptionBanner(totalAvailable);
            }
        }
    };
})();
